import styled from 'styled-components';

export default styled.div`
  width: 600px;
  display: flex;
  gap: 8px;
  align-items: center;
  .step-item {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    width: 108px;
    height: 40px;
    border-radius: 20px;
    background-color: #f5f6f9;
    .step-number {
      width: 24px;
      height: 24px;
      border-radius: 12px;
      background-color: #fff;
      border: 1px solid #666666;
      color: #666666;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .step-label {
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      color: #666666;
    }

    &.form-done {
      background-color: #c8e0ff;
      .check-wrap {
        background-color: #fff;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .step-label {
        color: #1565c0;
      }
    }
    &.active {
      background-color: #1565c0;
      .step-number {
        background-color: #fff;
        color: #1565c0;
      }
      .step-label {
        color: #fff;
      }
    }
  }
  .step-line {
    width: 122px;
    border-width: 4px;
    border: 4px solid #f5f6f9;
  }
`;
